import React from "react";
import {
  Box,
  Container,
  Flex,
  Stack,
  Text,
  Heading,
  Input,
  Button,
  HStack,
  VStack,
  Divider,
  Image,
} from "@chakra-ui/react";
import {
  ArrowForwardIcon,
  EmailIcon,
  PhoneIcon,
  ExternalLinkIcon,
} from "@chakra-ui/icons";
import sylvr_logo from "../../assets/images/sylvr-logo-register.png";

const Footer = () => {
  return (
    <Box bg="#161F2C" color="gray.300" pt={20} pb={12}>
      <Container maxW="7xl">

        {/* ================= TOP SECTION — Subscribe ================= */}
        <Flex
          direction={{ base: "column", lg: "row" }}
          justify="space-between"
          align={{ base: "flex-start", lg: "center" }}
          gap={6}
          pb={12}
        >
          <Box>
            <Heading
              fontSize="3xl"
              fontFamily="serif"
              fontWeight="bold"
              color="white"
            >
              Get market intelligence updates
            </Heading>
            <Text mt={2} color="gray.400">
              Weekly insights for manufacturing leaders. No spam, unsubscribe anytime.
            </Text>
          </Box>

          {/* Subscribe Input */}
          <HStack
            spacing={3}
            w="full"
            maxW={{ base: "full", lg: "md" }}
          >
            {/* <Input
              placeholder="Enter your work email"
              bg="#1E2A38"
              border="1px solid"
              borderColor="gray.600"
              py={6}
              px={6}
              borderRadius="xl"
              _focus={{ boxShadow: "0 0 0 1px #4299E1" }}
            /> */}

            {/* <Button
              bg="#2AA198"
              color="white"
              px={8}
              py={6}
              borderRadius="xl"
              _hover={{ bg: "#244A88" }}
              rightIcon={<ArrowForwardIcon />}
            >
              Subscribe
            </Button> */}
          </HStack>
        </Flex>

        <Divider borderColor="gray.700" />

        {/* ================= MAIN FOOTER CONTENT ================= */}
        <Flex
          mt={12}
          direction={{ base: "column", lg: "row" }}
          justify="space-between"
          gap={12}
        >

          {/* Column 1 — Logo + About */}
          <Box w={{ base: "full", lg: "25%" }}>
            <Image
            src={sylvr_logo}
            alt="Sylvr Logo"
            h="44px"
            objectFit="contain"
          />

            <Text mt={4} color="gray.400" lineHeight="tall">
              Decision intelligence for small and medium manufacturers.
              Clarity from public data, no internal integration required.
            </Text>

            <HStack mt={6} spacing={3}>
              <EmailIcon boxSize={5} color="gray.400" />
              <Text>tech@sylvr.io</Text>
            </HStack>

            {/* Social Links (Chakra Only Version) */}
            <HStack mt={6} spacing={4}>
             <Button
  as="a"
  href="https://www.linkedin.com/company/sylvr-by-50een/"
  target="_blank"
  rel="noopener noreferrer"
  size="sm"
  bg="#1E2A38"
  color="gray.300"
  borderRadius="xl"
  rightIcon={<ExternalLinkIcon />}
  _hover={{ bg: "#2A3A4E" }}
>
  LinkedIn
</Button>

              <Button
  as="a"
  href="https://www.youtube.com/@Sylvr-app"
  target="_blank"
  rel="noopener noreferrer"
  size="sm"
  bg="#1E2A38"
  color="gray.300"
  borderRadius="xl"
  rightIcon={<ExternalLinkIcon />}
  _hover={{ bg: "#2A3A4E" }}
>
  YouTube
</Button>
            </HStack>
          </Box>

          {/* Column 2 — Product */}
          <Box w={{ base: "full", lg: "20%" }}>
            <Heading size="md" color="white" mb={4}>
              PRODUCT
            </Heading>
            <VStack align="start" spacing={3} color="gray.400">
              <Text _hover={{ color: "white" }} cursor="pointer">How It Works</Text>
              <Text _hover={{ color: "white" }} cursor="pointer">Why Us</Text>
              <Text _hover={{ color: "white" }} cursor="pointer">Pricing</Text>
              <Text _hover={{ color: "white" }} cursor="pointer">Request Demo</Text>
            </VStack>
          </Box>

          {/* Column 3 — Resources */}
          <Box w={{ base: "full", lg: "20%" }}>
            <Heading size="md" color="white" mb={4}>
              RESOURCES
            </Heading>
            <VStack align="start" spacing={3} color="gray.400">
              <Text _hover={{ color: "white" }} cursor="pointer">Blog & Insights</Text>
              <Text _hover={{ color: "white" }} cursor="pointer">Case Studies</Text>
              <Text _hover={{ color: "white" }} cursor="pointer">Help Center</Text>
              <Text _hover={{ color: "white" }} cursor="pointer">Manufacturing Guides</Text>
            </VStack>
          </Box>

          {/* Column 4 — Legal */}
          <Box w={{ base: "full", lg: "20%" }}>
            <Heading size="md" color="white" mb={4}>
              LEGAL
            </Heading>
            <VStack align="start" spacing={3} color="gray.400">
              <Text _hover={{ color: "white" }} cursor="pointer">Privacy Policy</Text>
              <Text _hover={{ color: "white" }} cursor="pointer">Terms of Service</Text>
              <Text _hover={{ color: "white" }} cursor="pointer">Cookie Policy</Text>
            </VStack>
          </Box>

        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
